import React from 'react';
import { func } from 'prop-types';

import { bem, TRACK_ID } from './index';

export class Track extends React.Component {
    render() {
        const { onMouseDown, onTouchStart } = this.props;
        return (
            <div
                className={bem('track')}
                onMouseDown={(e) => onMouseDown(e, { handleID: TRACK_ID, isTouch: false })}
                onTouchStart={(e) => onTouchStart(e, { handleID: TRACK_ID, isTouch: true })}
            />
        );
    }
}

Track.propTypes = {
    onMouseDown: func.isRequired,
    onTouchStart: func.isRequired,
};
